import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=54421996&scoped=true&"
import script from "./homview?vue&type=script&lang=js&"
export * from "./homview?vue&type=script&lang=js&"
import style0 from "./homeview.scss?vue&type=style&index=0&id=54421996&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54421996",
  null
  
)

export default component.exports